import {Component, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {NgbCollapse, NgbDropdownModule, NgbNav, NgbTooltip} from "@ng-bootstrap/ng-bootstrap";
import {Router, RouterLink, RouterLinkActive, RouterOutlet} from "@angular/router";
import {ToastService} from "../../core/notifications/toast-service";
import {AuthenticationService} from "../../services/authentication.service";
import { NgClass } from "@angular/common";
import {AuthorizationService} from "../../services/authorization.service";
import {BreakpointObserver, Breakpoints} from "@angular/cdk/layout";
import {Subscription} from "rxjs";
import {FormsModule} from "@angular/forms";
import {updateUserAttribute, type UpdateUserAttributeOutput} from 'aws-amplify/auth';
import {SeasonService} from "../../services/season.service";
import {APP_VERSION} from "../../../environments/version";

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    NgbNav,
    NgbCollapse,
    RouterOutlet,
    RouterLink,
    RouterLinkActive,
    NgClass,
    NgbDropdownModule,
    FormsModule,
    NgbTooltip
],
  templateUrl: './home.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './home.component.scss'
})
export class HomeComponent implements OnInit, OnDestroy {
  version = APP_VERSION;



  navbarCollapsed = false;
  isMobile: boolean = false;
  private breakpointSubscription!: Subscription;
  prices_url: string = ""

  constructor(private authService: AuthenticationService,
              private permissionService: AuthorizationService,
              private toastService: ToastService,
              private breakpointObserver: BreakpointObserver,
              private seasonService: SeasonService) {
  }

  logout() {
    this.authService.signOut()
      .catch(() => this.toastService.showDanger("Ausloggen fehlgeschlagen"));
  }

  showAdminLink(): boolean {
    return this.permissionService.isAdmin();
  }

  ngOnInit(): void {
    this.breakpointSubscription = this.breakpointObserver
      .observe([Breakpoints.Handset])
      .subscribe(result => {
        this.isMobile = result.matches;
      });

    this.seasonService.get_prices_url()
      .then(res => {
        this.prices_url = res.url;
      })
      .catch(error => {
        this.toastService.showDanger("Patreon Preise konnten nicht geladen werden!");
      })
  }

  ngOnDestroy() {
    this.breakpointSubscription.unsubscribe();
  }
}
